
import { GlobalControl } from "./globalControl";
import { VeryNettyPara } from "./veryNetty/VeryNettyPara";
import { VeryCharacter } from "./veryNetty/VeryCharacter";
import { SocketManager } from "./veryNetty/SocketManager";
import { VeryList, VeryString, VeryNumber } from "./veryNetty/veryVariables";
import { Exhibits } from "./exhibits";
import { Game, runBtn } from "../main";
import PerfectScrollbar from "perfect-scrollbar";
import QRCode from "qrcode";
//界面按钮注册事件
export class uiBtnEvent {
  private isMute: boolean = false;
  private onlineNumber = new VeryNumber("onlineNumber", 0);
  private directNavIsVisible: boolean = true;

  constructor() {
    //bootstrap ui
    $("[data-toggle='popover']").popover();
    $("[data-toggle='tooltip']").tooltip();

    $("#collapse1,#collapse2,#collapse3,#collapse4,#collapse5,#collapse6,#collapse7,#collapse8,#collapse9").on('show.bs.collapse', function () {
      let element = this.parentElement.firstElementChild.firstElementChild
      element.className = "iconfont icon-arrow-expended"
    })
    $("#collapse1,#collapse2,#collapse3,#collapse4,#collapse5,#collapse6,#collapse7,#collapse8,#collapse9").on('hide.bs.collapse', function () {
      let element = this.parentElement.firstElementChild.firstElementChild
      element.className = "iconfont icon-arrow-collapsed"
    })


    //diy界面
    // 菜单按钮点击切换菜单显示隐藏
    $(".menu").on("click", () => {
      // 防止边前进边点击ui导致前进不停
      VeryCharacter.isStopMove = true
      $(".menu-tri").delay(300).slideToggle()
      $(".menu-list").slideToggle(300);
      $(".share-btn,.support-btn,.map-btn,.profile-btn,.translate-btn,.resume-btn").removeClass(
        "btn-selected"
      );
      $(".profile-box,#tepCanvas,.support-box,.share-box,.bu-board-box").hide();
    });

    //more btn
    $(".icon-gengduo").on("click", () => {
      $(".more-tri").delay(300).slideToggle()
      $(".more-list").slideToggle(300);
    });

    //性别选择
    $("input[type='radio']").on("click", function () {
      if ($("input[name='gender']:checked").val() == "m") {
        $(".icon--nan").css({
          'display': 'none'
        });
        $(".icon--nv").css({
          'display': 'inline-block'
        })
      } else {
        $(".icon--nv").css({
          'display': 'none'
        });
        $(".icon--nan").css({
          'display': 'inline-block'
        })
      }
    })
    $('body').click(function (e) {
      var target = $(e.target);
      if (!target.is('.waijing-sample') && !target.is('.panoSetting-ref')) {
        if ($('.waijing-sample').is(':visible')) {
          $('.waijing-sample').hide();
        }
      }
    });

    // 功能按钮点击变色，打开对应功能面板，并关闭其他面板
    const ulBtnNode = $(
      ".share-btn,.support-btn,.resume-btn,.map-btn,.profile-btn,.signboard-btn,.common-btn,.bgm-btn,.commentary-btn,.caizhitihuan-btn,.initPostion-btn,.to360-btn"
    );
    ulBtnNode
      .off("click")
      .on("click", (e) => {
        // 防止边前进边点击ui导致前进不停
        VeryCharacter.isStopMove = true
        let htmlNode: JQuery<HTMLElement>;
        if (e.target.tagName === "SPAN") {
          htmlNode = $(e.target).parent();
        } else {
          htmlNode = $(e.target);
        }
        ulBtnNode.removeClass("btn-selected");
        htmlNode.toggleClass("btn-selected");

      });
    $(".setup-btn,.sound-Mute-btn,.vir-btn").off("click").on("click", (e) => {
      // 防止边前进边点击ui导致前进不停
      VeryCharacter.isStopMove = true
      let htmlNode: JQuery<HTMLElement>;
      if (e.target.tagName === "SPAN") {
        htmlNode = $(e.target).parent();
      } else {
        htmlNode = $(e.target);
      }
      htmlNode.toggleClass("btn-selected");
    });
    //交换名片面板
    $(".exchange-refuse").on("click", () => {
      $(".exchange").hide();
    });
    $(".exchange-agree").on("click", () => {
      $(".exchange").hide();
    });

    // 打开个人信息面板
    $(".profile-btn").on("click", () => {
      this.closeall();
      if (!Exhibits.hasLogin) {
        $(".login-box :text").each(function () {
          $(this).val("")
        });
        $(".login-box").toggle(200);
      } else {
        $(".profile-box").toggle(200);
      }
    });
    //打开名片盒面板
    $(".contacts-btn").on("click", () => {
      this.closeall();
      $(".cardcase-box").show();
    });
    // //打开名片盒面板
    // $(".icon-tongxunlu").on("click", () => {
    //   this.closeall();
    //   $(".cardcase-box").show();
    // });

    // 设置滚动条
    const cardcaseScrollbar = new PerfectScrollbar("#cardcase-box-main", {
      suppressScrollX: true,
    });
    const onlineChatScrollbar = new PerfectScrollbar("#online-chat-list", {
      suppressScrollX: true,
    });

    //方向导航键显示按钮
    $(".vir-btn").on("click", () => {
      this.directNavIsVisible = !this.directNavIsVisible;
      Exhibits.grid.isVisible = this.directNavIsVisible;
    })
    // 这就是目录
    $(".link-btn").on("click", () => {
      this.closeall();
      $(".link-board-box").toggle(200);
    });
    //大数据链接按钮
    $(".bigData-btn").on("click", () => {
      let link = "http://39.104.131.145:8088/Expo/" + VeryNettyPara.ProjectID
      window.open(link)
    })

    // 打开切换展馆面板
    $(".map-btn").on("click", () => {
      this.closeall();
      $(".icon-daohang,.icon-daohangw").toggleClass(
        "icon-daohang icon-daohangw"
      );
      $("#tepCanvas").toggle(200)
    });

    $('body').click(function (e) {
      var target = $(e.target);
      if (!target.is('#tepCanvas') && !target.is('.map-btn') && !target.is('.map-btn span')) {
        if ($('#tepCanvas').is(':visible')) {
          $("#tepCanvas").hide(150, "linear");
          $("#bg").hide();
          that.removeallbg()
        }
      }
    });

    // 点击切换语言
    if (this.getCookie("language") === "0") {
      $(".translate-btn .iconfont").addClass("icon-multi-language-02");
    } else {
      $(".translate-btn .iconfont").addClass("icon-multi-language-01");
    }
    $(".translate-btn").on("click", () => {
      $(".caizhitihuan-btn,.commentary-btn,.bgm-btn,.common-btn,.initPostion-btn,.to360-btn").css(
        "display",
        "none"
      );
      $(".setup-btn").removeClass("btn-selected")
      this.removeallbg()
      this.closeall()
      $("#bg").hide()
      let flag = $(".translate-btn .iconfont").hasClass(
        "icon-multi-language-02"
      );
      if (flag) {
        $(".translate-btn .iconfont").removeClass("icon-multi-language-02");
        $(".translate-btn .iconfont").addClass("icon-multi-language-01");
      } else {
        $(".translate-btn .iconfont").removeClass("icon-multi-language-01");
        $(".translate-btn .iconfont").addClass("icon-multi-language-02");
      }
      let lang = parseInt(this.getCookie("language"));
      if (lang) {
        this.setCookie("language", 0, 365);
      } else {
        this.setCookie("language", 1, 365);
      }
      // runBtn();
      window.location.reload()
    });
    // 打开分享面板
    $(".share-btn").on("click", () => {
      this.closeall();
      let qrcode: any = document.getElementById("qrcode");
      let localURL = window.location.href;
      QRCode.toCanvas(
        qrcode,
        localURL,
        {
          errorCorrectionLevel: "H",
          type: "image/jpeg",
          quality: 0.3,
          width: 148,
          margin: 1,
        },
        function (error) {
          if (error) console.error(error);
          console.log("success!");
        }
      );
      let dataURL = qrcode.toDataURL("image/png");
      $("#share-link-text").val(localURL);
      $("#save-qr-btn").attr("href", dataURL);
      $(".share-box").toggle(200);
    });
    // 打开技术支持页面
    $(".support-btn").on("click", () => {
      this.closeall();
      $(".support-box").toggle(200);
    });
    // wsm
    // 分厅目录
    $(".directory-btn").on("click", () => {
      console.log(Game.directoryData["directory"]);
      if (!Game.directoryData["directory"]) {
        return
      }
      this.closeall();
      $(".directory-main").html("");
      $(".directory-main").append(`<div class="directory-end"></div>`);
      if (Game.directoryData["directory"].length > 1) {
        $(".directory-board-box").css("width", 78 * Game.directoryData["directory"].length + 76)
        $(".directory-main").css("marginLeft", 52)
        // $(".directory-main").css("left", 52)
      } else {
        // 目录只有一个的时候防止盒子太窄变形，让这个目录条居中
        // $(".directory-main").css("left", 90)
        $(".directory-main").css("marginLeft", 90)
      }
      let isAllImg = 0
      Game.directoryData["directory"].map((it, index) => {
        let htmlLink;
        if (it.imgUrl) {
          isAllImg++
          htmlLink = ` <div class="directory-list-img">
          <img class="directory-img" src="${it.imgUrl}" alt="" href="${it.url}"></img>
          </div>`
        } else
          htmlLink = ` <div class="directory-list">
           <img class="directory-list-icon" src="./images/exhibits/directoryhome.svg" alt="" >
           <a class="directory-list-name" href="${it.url}">${it.name}</a>
           </div>`
        $(".directory-end").before(htmlLink);
      })
      $(".directory-board-box").toggle(200);
    });
    $(".directory-board-box").on("click", ".directory-img", (e) => {
      let url = $(e.target).attr("href")
      window.open(url + window.location.search, "_self");
    })
    // 是否静音
    $(".sound-Mute-btn").on("click", () => {
      this.isMute = !this.isMute;
      $(".icon-sound-Mute,.icon-sound-filling").toggleClass(
        "icon-sound-Mute icon-sound-filling"
      );
      GlobalControl.mute(this.isMute);
    });

    //一级面板右上角小叉，点击关闭对应的面板
    $(".close").on("click", (e) => {
      $(e.target).parent().hide(150, "linear");
      $("#bg").hide();
      Exhibits.imgBlob = null
      this.removeallbg()
    })
    //login close btn
    $(".icon-guanbi1").on("click", (e) => {
      $(".login-box").hide(150, "linear");
      $("#bg").hide();
      this.removeallbg()
    })
    //二级面板右上角小叉，点击关闭对应的面板
    $(".close2").on("click", (e) => {
      $(e.target).parent().hide(150, "linear");
      $("#bg").css({ "z-index": 1 })
    })
    //三级面板右上角小叉，点击关闭对应的面板
    $(".close3").on("click", (e) => {
      $(e.target).parent().hide(150, "linear");
      $("#bg").css({ "z-index": 100 })
    })
    // 点击打开封面编辑
    $(".common-btn").on("click", () => {
      this.closeall();
      $(".diy-common").show();
    });
    // 打开公告栏，并获取数据
    $(".signboard-btn").on("click", () => {
      this.closeall();
      if ($(".bu-board-box").is(":hidden")) {
        SocketManager.Instance.ValTimeCount("test", false, null, null, true,
          (data) => {
            let count = data.count;
            let total = data.total;
            let avgTime = (total / count / 60) >> 0;
            $(".views-total p.boardNum").text(count);
            $(".avg-time p.boardNum").text(avgTime + '"');
            $(
              ".views-total .sk-fading-circle, .avg-time .sk-fading-circle"
            ).hide();
          }
        );
        SocketManager.Instance.ValTimeCount("test", false, null, null, false,
          (data) => {
            let count = data.count;
            $(".views-today p.boardNum").text(count);
            $(".views-today .sk-fading-circle").hide();
          }
        );
        SocketManager.Instance.GetValues([this.onlineNumber], false, 812,
          () => {
            $(".online-total p.boardNum").text(this.onlineNumber.value);
            $(".online-total .sk-fading-circle").hide();
          }
        );
      }

      $(".bu-board-box").toggle();
    });
    // 打开帮助提示
    $(".shubiao-btn").on("click", () => {
      // 防止边前进边点击ui导致前进不停
      VeryCharacter.isStopMove = true
      this.closeall();
      this.removeallbg()
      $(".operating-instructions-box").show();
    });
    // 复制分享链接
    $(".share-link-copy").on("click", () => {
      var obj = $("#share-link-text");
      //选择当前对象
      obj.select();
      try {
        //进行复制到剪切板
        if (document.execCommand("copy", false, null)) {
          //如果复制成功
          alert("复制成功！");
        } else {
          //如果复制失败
          alert("复制失败！");
        }
      } catch (err) {
        //如果报错
        alert("复制错误！");
      }
    });
    // diy界面出现隐藏

    $(".diy-pic-cancel").on("click", () => {
      $(".diy-pic").hide();
      $("#diy-pic-title-input").val("");
      $("#diy-pic-en-title-input").val("");
      $("#diy-pic-des-input").val("");
      $("#diy-pic-des-en-input").val("");
      $("#diy-pic-file").val("");
      $("#bg").hide()
    });
    $(".diy-pic-save").on("click", () => {
      $(".diy-pic").hide();
    });
    //二级页面触发
    $(".icon-lianjie-DIY").on("click", () => {
      $("#bg").show();
      $(".diy-pic-link").toggle(200);
      $("#bg").css({ "z-index": 100 })
    });
    $(".icon-shipin-DIY").on("click", () => {
      $("#bg").show();
      $(".diy-videos").toggle(200);
      $("#bg").css({ "z-index": 100 })
    });
    $(".icon-3D-DIY").on("click", () => {
      $("#bg").show();
      $(".diy-models").toggle(200);
      $("#bg").css({ "z-index": 100 })
    });
    $(".icon-360-DIY").on("click", () => {
      $("#bg").show();
      $(".diy-pic-360-link").toggle(200);
      $("#bg").css({ "z-index": 100 })
    });
    $(".icon-tuji-DIY").on("click", () => {
      $("#bg").show();
      $(".diy-album").toggle(200);
      $("#bg").css({ "z-index": 100 })
    });
    $(".icon-pdf-DIY").on("click", () => {
      $("#bg").show();
      $(".diy-pic-pdf").toggle(200);
      $("#bg").css({ "z-index": 100 })
    });
    $(".icon-beijingyin").on("click", () => {
      $("#bg").show();
      $(".diy-pic-audio").toggle(200);
      $("#bg").css({ "z-index": 100 })
    });

    $(".diy-pic-link-cancel").on("click", () => {
      $("#bg").hide();
      $(".diy-pic-link").toggle(200);
    });
    $(".diy-pic-360-link-cancel").on("click", () => {
      $("#bg").hide();
      $(".diy-pic-360-link").toggle(200);
    });

    $("input[type='radio']").on("click", function () {
      if ($("input[name='language']:checked").val() == "1") {
        $(".diy-pic-des").css("margin-top", "0px");
      } else {
        $(".diy-pic-des").css("margin-top", "-203px");
      }
    })
    // 图集UI显示隐藏
    $(".diy-album-add-language .diy-album-add-chinese,.diy-album-add-language .diy-album-add-english").on("click", (e) => {
      $(".diy-album-add-language .diy-album-add-chinese,.diy-album-add-language .diy-album-add-english").removeClass("btn-selected");
      $(e.target).addClass("btn-selected");
      if (e.target.innerText === "EN") {
        $(".diy-album-cn-box").css("margin-top", "-185px");
      } else {
        $(".diy-album-cn-box").css("margin-top", "0px");
      }
    });

    $(".exchange-agree").on("click", () => {
      if ($("#auto").attr("src")) {
        const auto = $("#auto").get(0) as HTMLAudioElement
        auto.play()
      } else {
        $("#auto").attr("src", "./信息交换提示音.mp3");
      }
    })
    const that = this;
    window.addEventListener("beforeunload", function () {
      if (VeryNettyPara.UserName !== "游客") {
        SocketManager.Instance.OperateNum(that.onlineNumber, "-", 811, () => {
          console.log(that.onlineNumber);
        });
      }
      SocketManager.Instance.valTimeClose();
      return "关闭提示";
    });
  }
  //切换按钮状态
  public btnSwitch(htmlnode: string) {
    return $(htmlnode).on("click", (e) => {
      $(htmlnode).removeClass("btn-selected");
      $(e.target).addClass("btn-selected");
    });
  }
  //初始化筛选区域文字
  public initArea(num: number, lang: number) {
    const arr = [0, 1, 2];
    const newArr: number[] = arr.slice(num);
    let initAlert = lang
      ? ["Area", "Category", "Company"]
      : ["选择展区", "选择展会", "选择展台"];
    let initnode = ["selector-area", "selector-category", "selector-company"];
    newArr.map((it) => {
      let node = initnode[it];
      $(`div.${node}`).text(initAlert[it]);
      $(`ul.${node}`).empty().hide();
    });
  }
  //设置cookie
  private closeall() {
    $(
      ".diy-model-change,.operating-instructions-box,#bg,.profile-box,.login-box,.register-box,.Reregister-box,.cardcase-box,.share-box,#tepCanvas,.support-box,.profile-edit,.bu-board-box,.diy-bgm,.diy-des,.diy-common,.diy-big,.diy-pic,.diy-pic-link,.diy-pic-video,.diy-pic-model,.diy-pic-360-link,.diy-album,.diy-album-add-box,.diy-pic-pdf,.diy-pic-audio,.diy-video,.diy-tietu,.diy-question,.diy-exhibitLink,.diy-model,.diy-model-model,.diy-material,.waijing-sample"
    ).hide();
    $("#bg").show()
  }
  private removeallbg() {
    const ulBtnNode = $(
      ".share-btn,.support-btn,.resume-btn,.map-btn,.profile-btn,.signboard-btn,.common-btn,.bgm-btn,.commentary-btn,.caizhitihuan-btn,.initPostion-btn,.to360-btn"
    );
    ulBtnNode.removeClass("btn-selected");
  }
  public setCookie(cname: string, cvalue: number, exdays: number) {
    var d = new Date();
    d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000);
    var expires = "expires=" + d.toUTCString();
    document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
  }

  public getCookie(cname: string) {
    var name = cname + "=";
    var ca = document.cookie.split(";");
    for (var i = 0; i < ca.length; i++) {
      var c = ca[i];
      while (c.charAt(0) == " ") {
        c = c.substring(1);
      }
      if (c.indexOf(name) == 0) {
        return c.substring(name.length, c.length);
      }
    }
    return "";
  }
}
